import { render, staticRenderFns } from "./table_view.vue?vue&type=template&id=5a4d6dda&scoped=true"
import script from "./table_view.vue?vue&type=script&lang=js"
export * from "./table_view.vue?vue&type=script&lang=js"
import style0 from "./table_view.vue?vue&type=style&index=0&id=5a4d6dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4d6dda",
  null
  
)

export default component.exports